import React from "react";
import { useSelector } from "react-redux";
import { Typography, Button } from "@material-ui/core";
import { Root, User } from "../../styles";
import TimeStats from "../time-stats";
import Link from "../../../../components/plain-link";
import ProfilePicture from "../../../../components/profile-picture";
import useStyles from "./styles";

export default function SelfProfile() {
  const classes = useStyles();
  const profilePicture = useSelector(
    (state) => state.userPreferences.profilePicture
  );
  const displayName = useSelector((state) => state.userPreferences.displayName);
  const username = useSelector((state) => state.userPreferences.username);
  const studyTime = useSelector((state) => state.studyData.studyTime);

  return (
    <Root>
      <User>
        <ProfilePicture
          picturePath={profilePicture}
          className={classes.profilePicture}
        />
        <Typography variant="h1" className={classes.displayName}>
          {displayName}
        </Typography>
        <Typography className={classes.username}>
          username: {username}
        </Typography>
        <div className={classes.buttons}>
          <Link to="/settings">
            <Button className={classes.settings}>Settings</Button>
          </Link>
          <div style={{ width: "1rem" }} />
          <Link to="/">
            <Button
              variant="outlined"
              color="primary"
              className={classes.logout}
            >
              Logout
            </Button>
          </Link>
        </div>
      </User>
      <div className={classes.displayStats}>
        <TimeStats time={studyTime} />
      </div>
    </Root>
  );
}
